import type { WalletType } from '@api';

import { walletIconMappings } from '@shared/constants/wallets';

const getToastIcon = (walletType: WalletType) => {
  const Icon = walletIconMappings[walletType];

  return (
    <span className="icon">
      <Icon />
    </span>
  );
};

export default getToastIcon;
